module.exports = __webpack_public_path__ + "img/Poorter_hotel-181.8ddaa8a8.jpg";